import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccountInactive = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.icon}>⚠️</div>
        <h1 style={styles.title}>Account Inactive</h1>
        <p style={styles.message}>
          Your account has been deactivated. All of your access cards are currently inactive.
        </p>
        <p style={styles.subMessage}>
          Please contact your system administrator if you believe this is an error.
        </p>
        <button 
          onClick={() => navigate('/login')} 
          style={styles.button}
        >
          Return to Login
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 64px)',
    backgroundColor: '#f8f9fa',
    padding: '2rem'
  },
  content: {
    textAlign: 'center',
    backgroundColor: 'white',
    padding: '3rem',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    maxWidth: '500px',
    width: '100%'
  },
  icon: {
    fontSize: '4rem',
    marginBottom: '1rem'
  },
  title: {
    fontSize: '2rem',
    color: '#dc3545',
    marginBottom: '1rem',
    fontWeight: '600'
  },
  message: {
    fontSize: '1.1rem',
    color: '#333',
    marginBottom: '0.5rem',
    lineHeight: '1.6'
  },
  subMessage: {
    fontSize: '0.95rem',
    color: '#666',
    marginBottom: '2rem',
    lineHeight: '1.6'
  },
  button: {
    padding: '0.75rem 2rem',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '1rem',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'background-color 0.2s',
  }
};

export default AccountInactive;
